import { Component, Input } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportTask } from '../../model/transport-task';
import { ClientStatusService } from '@sdbn/common';
import { TaskType } from '../../model/task-type.enum';

@Component({
    selector: 'app-task-list-entry',
    templateUrl: './task-list-entry.component.html',
    styleUrls: ['./task-list-entry.component.scss'],
    standalone: false
})
export class TaskListEntryComponent {

  @Input()
  task: TransportTask;

  @Input()
  selected: boolean;

  taskType = TaskType;

  constructor(
    public translationService: TranslationService,
    public clientStatusService: ClientStatusService
    ) {
  }

}
